"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var http_1 = require("@angular/common/http");
/**
 * KeywordSearch imports
 */
var config_1 = require("../../config");
// using custom encoder for http params in order to have escaped + signs
var CustomEncoder = /** @class */ (function () {
    function CustomEncoder() {
    }
    CustomEncoder.prototype.encodeKey = function (key) {
        return encodeURIComponent(key);
    };
    CustomEncoder.prototype.encodeValue = function (value) {
        // same as original encoding, but not replacing %2B back to +
        return encodeURIComponent(value)
            .replace(/%40/gi, '@')
            .replace(/%3A/gi, ':')
            .replace(/%24/gi, '$')
            .replace(/%2C/gi, ',')
            .replace(/%3B/gi, ';')
            .replace(/%3D/gi, '=')
            .replace(/%3F/gi, '?')
            .replace(/%2F/gi, '/');
    };
    CustomEncoder.prototype.decodeKey = function (key) {
        return decodeURIComponent(key);
    };
    CustomEncoder.prototype.decodeValue = function (value) {
        return decodeURIComponent(value);
    };
    return CustomEncoder;
}());
var KeywordSearchService = /** @class */ (function () {
    function KeywordSearchService(http) {
        this.http = http;
        this.FILTER_SEPERATOR = ':';
    }
    /**
     * Loads the initial config for KeywordSearch placed by SiteCore in DOM
     */
    KeywordSearchService.prototype.getConfig = function () {
        // use config from DOM placed as JSON in html file
        var result = config_1.extractConfigFromDom();
        // cache the config
        this.config = result;
        // return the configuration to the calling component for further use
        return rxjs_1.of(result);
    };
    return KeywordSearchService;
}());
exports.KeywordSearchService = KeywordSearchService;
